{
  "lastUpdatedAt": "2026-06-18T07:17:33.731Z",
  "lastFetchAttemptAt": "2026-06-18T07:17:33.731Z",
  "organization": null,
  "parseError": null,
  "fetchError": null
}